import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-89f56fb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "chat-container",
  ref: "chatContainer"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "bubble-header" }
const _hoisted_4 = ["fill"]
const _hoisted_5 = ["fill"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z" }, null, -1))
const _hoisted_7 = { class: "bubble-content" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.currentMessages.length == 15)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(['more-info', { 'dark-mode': _ctx.isDarkMode }])
        }, " <<" + _toDisplayString(_ctx.$t('chat.moreHistory')) + ">> ", 3))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentMessages, (message, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass(['chat-bubble', message.type, { 'dark-mode': _ctx.isDarkMode }]),
        onClick: ($event: any) => (_ctx.showButtons(index))
      }, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(), _createElementBlock("svg", {
            class: "svg",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            fill: _ctx.fillColor,
            width: "24",
            height: "24"
          }, [
            _createElementVNode("circle", {
              cx: "12",
              cy: "12",
              r: "8",
              fill: _ctx.fillBGColor
            }, null, 8, _hoisted_5),
            _hoisted_6
          ], 8, _hoisted_4)),
          _createElementVNode("span", {
            class: _normalizeClass(['msg-text', 'eg-' + message.type])
          }, _toDisplayString(_ctx.$t(`chat.${message.type}`)), 3)
        ]),
        _createElementVNode("div", _hoisted_7, _toDisplayString(message.text), 1),
        (message.showButtons && message.type == 'you')
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(['button-container', { show: message.showButtons }])
            }, [
              _createElementVNode("button", {
                onClick: ($event: any) => (_ctx.handleButtonClick('copy', message.text))
              }, _toDisplayString(_ctx.$t('chat.copy')), 9, _hoisted_8),
              _createElementVNode("button", {
                onClick: ($event: any) => (_ctx.handleButtonClick('retry', message.text))
              }, _toDisplayString(_ctx.$t('chat.retry')), 9, _hoisted_9)
            ], 2))
          : _createCommentVNode("", true)
      ], 10, _hoisted_2))
    }), 128))
  ], 512))
}